import { useState, useEffect } from 'react';
import { getTargetElement } from 'ahooks/lib/utils/domTarget';
export default function useFirstInView(target, options = {}) {
    const [state, setState] = useState(false);
    useEffect(() => {
        const element = getTargetElement(target);
        if (!element)
            return;
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setState(true);
                observer.unobserve(element);
            }
        }, Object.assign(Object.assign({}, options), { root: getTargetElement(options === null || options === void 0 ? void 0 : options.root) }));
        observer.observe(element);
        return () => {
            observer.disconnect();
        };
    }, []);
    return state;
}
//# sourceMappingURL=index.js.map